var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-14 flex items-center justify-center w-full",staticStyle:{"background-color":"#0d0d0d"}},[_c('span',{staticClass:"text-white text-bold"},[_vm._v("Unibagué "+_vm._s(_vm.year))])])
}
var staticRenderFns = []

export { render, staticRenderFns }